import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class FeeProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'prices/fees'

  getByType(type: string, carrierHandle: string) {
    return this.submit('get', `/${this.endpoint}?type=${type}&carrierHandle=${carrierHandle}`)
  }
}
